function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#231f20;}"));

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "NEW LAB CITY logo");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M184.4048,324.8021,178.5,310.5728l5.9258,0v-1.2791l-26.35,0v1.2791h2.388l11.1285,27.1964h1.2366l5.33-11.505,5.2016,11.505h1.1087l-.0646-12.9671Zm-9.2307,5.0012-7.8031-19.2305h4.4773l5.6283,13.9859Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M189.998,337.7236v-1.2664h0V310.793h0v-1.2663h10.8906v1.2663h-3.7992v25.6642h4.7276c4.77,0,6.5428-3.9678,7.8514-7.9779H210.85l-.4222,9.2443Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M211.8869,337.7236a16.7023,16.7023,0,0,0,1.2024-2.4906l9.9854-25.9176h1.6463l10.4447,27.1418h2.5326v1.2664H224.3175v-1.2664h3.25l-2.28-6.6271H216.635l-1.0973,3.0391a14.3943,14.3943,0,0,0-.8443,2.87c0,1.0553,3.2081.7176,3.7989.7176v1.2664Zm5.2968-9.16h7.5982l-3.757-10.3418Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M239.3105,337.7236v-1.2664h0V310.793h-2.9968v-1.2663h15.7022c3.6724,0,8.6535,1.7728,8.949,6.2051.211,3.208-1.8576,6.036-8.2736,7.26v.0843c4.1789.1267,9.7086,2.1107,9.7086,7.2181,0,3.0392-2.0682,5.1075-4.5587,6.3317-2.1107,1.0553-4.8965,1.0975-7.1761,1.0975Zm7.0914-15.3227h1.8152c4.4742,0,5.4451-.5486,5.4451-6.2049,0-5.023-.1688-5.403-4.4742-5.403h-2.7861Zm4.9811,14.0563c3.7567,0,3.1659-3.3345,3.1659-6.3316,0-5.1074-.3377-6.4582-6.3318-6.4582h-1.8152v12.79Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M129.7929,337.7769h-1.1653l-18.0919-24.6435v21.8742c0,1.0659.5969,1.4923,1.6631,1.5776h2.43v1.2794h-9.3809v-1.2794h2.0467c1.45-.0853,1.5351-.9806,1.5351-2.2173V313.3042c0-2.0895.3837-2.6437-2.1747-2.6437h-1.4071v-1.2791h11.2569l11.9816,16.8853v-14.37c0-.8529-1.748-1.2366-2.8142-1.2366h-1.1938v-1.2791h8.9969v1.2791h-1.7908c-1.2366,0-1.9187.3837-1.9187,1.2366Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M132.0651,337.7769v-1.2794h3.4111V310.5728h0v-1.2791h20.2966l.2557,7.6751h-1.45c-1.7908-4.8185-3.6668-6.396-7.9308-6.396H142.64v11.8963c4.1788,0,5.0741-1.2366,5.9271-5.1594h1.407v12.11h-1.407c-.597-4.0932-1.7483-5.4579-5.9271-5.4579v12.5361h4.1788c6.6092,0,7.803-3.1127,8.9544-8.0588h1.3216l-.2557,9.3382Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-1",
  x1: 166.0758,
  y1: 0.0002,
  x2: 166.0758,
  y2: 35.9398
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 165.0756,
  width: 2,
  height: 35.9399
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M280.2482,323.5789a6.8565,6.8565,0,0,1,7.0488-7.09,6.0826,6.0826,0,0,1,5.1993,2.7127l-1.418.8014a4.61,4.61,0,0,0-3.7813-1.9933,5.577,5.577,0,0,0,0,11.1383,4.6627,4.6627,0,0,0,3.7813-1.9935l1.4384.781a6.1673,6.1673,0,0,1-5.22,2.7332A6.8565,6.8565,0,0,1,280.2482,323.5789Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M296.4044,330.4222V316.715H298.11v13.7072Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M306.2316,330.4222V318.2357h-4.3363V316.715h10.3986v1.5207h-4.3567v12.1865Z",
  transform: "translate(-105.2483 -305.6089)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M320.8692,330.4222v-5.7953l-5.4048-7.9119h1.9933l4.254,6.3707,4.2539-6.3707h1.9935l-5.3842,7.9119v5.7953Z",
  transform: "translate(-105.2483 -305.6089)"
});

var SvgLogo = function SvgLogo(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: "3.0932in",
    height: "0.4992in",
    viewBox: "0 0 222.7108 35.9399"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

export default __webpack_public_path__ + "static/media/logo.1f2a8c49.svg";
export { SvgLogo as ReactComponent };